(ns ui.editor2.media-limits)

(def max-image-file-size-bytes
  "Maximum file size for image uploads: 20 MB"
  (* 20 1024 1024))

(def max-image-dimension-pixels
  "Maximum width or height in pixels for image uploads"
  8000)
